import { render } from "./MenuInternational.vue?vue&type=template&id=11f22fc7&scoped=true"
import script from "./MenuInternational.vue?vue&type=script&lang=js"
export * from "./MenuInternational.vue?vue&type=script&lang=js"

import "./MenuInternational.vue?vue&type=style&index=0&id=11f22fc7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f22fc7"]])

export default __exports__